// gastosContext.js
import { createContext, useState, useContext, useCallback } from "react";

import {
  listarGastoXMetodoMapUseCase,
  listarGastoXMetodoUseCase,
} from "../../../core/gastos/application/listarGastoXMetodo.useCase.js";

export const GastosxMetodoContext = createContext(null);

export function useGastosxMetodo() {
  const context = useContext(GastosxMetodoContext);
  if (!context) {
    throw new Error(
      " [useGastosxMetodo]  debe usarse dentro de GastosxMetodoProvider",
    );
  }
  return context;
}

export function GastosxMetodoProvider({ children }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

const [gastosMetodo, setGastosMetodo] = useState([]);
const [gastosCategoria, setGastosCategoria] = useState([]);
  //
 const listarGastosMetodo = useCallback(async (filtros = {}) => {
  setLoading(true);
  setError(null);

  try {
    const data = await listarGastoXMetodoUseCase(filtros);

    setGastosMetodo(data ?? []);

    return data;

  } catch (error) {

    const mensaje = error?.message || "Error al listar gastos";
    setError(mensaje);

  } finally {
    setLoading(false);
  }

}, []);

  const listarGastosMetodoCategoria = useCallback(async (filtros = {}) => {
    console.log(
      "[listarGastoXMetodoMapUseCase.GastosVistasContext] Init",
      filtros,
    );

    setLoading(true);
    setError(null);

    try {
      const data = await listarGastoXMetodoMapUseCase(filtros);
      setGastosCategoria(data ?? []);
      console.log(
        "[listarGastoXMetodoMapUseCase.GastosVistasContext] success",
        {
          cantidad: data?.length || 0,
          data,
        },
      );
      return data;
    } catch (error) {
      const mensaje = error?.message || "Error al listar gastos";
      console.error(
        "[listarGastoXMetodoMapUseCase.GastosVistasContext]  Error",
        error,
      );
      setError(mensaje);
      throw new Error(mensaje);
    } finally {
      setLoading(false);
      console.log(
        "🏁 [listarGastoXMetodoMapUseCase.GastosVistasContext]  Finish",
      );
    }
  }, []);

  return (
    <GastosxMetodoContext.Provider
      value={{
        gastosMetodo,
        gastosCategoria,
        loading,
        error,
        listarGastosMetodo,
        listarGastosMetodoCategoria,
      }}
    >
      {children}
    </GastosxMetodoContext.Provider>
  );
}
